import React, { useState } from 'react';

interface IProps {
    isLiver?: boolean;
}

const Expectations = (props: IProps) => {
    const { isLiver } = props;
    const [expanded, setExpanded] = useState(false);

    return (
        <div style={{ marginTop: 20 }}>
            <ul className='nav nav-tabs' style={{ marginBottom: 0, borderBottom: expanded ? '1px solid #ddd' : '0px none' }}>
                <li className={'active'} style={{ marginBottom: expanded ? -1 : 0 }} onClick={() => setExpanded(!expanded)}>
                    <a style={{ fontWeight: 700, fontSize: 14, letterSpacing: 0.5, display: 'flex', justifyContent: 'space-between', borderBottomColor: expanded ? 'transparent' : '#ddd' }}>
                        <strong style={{ fontSize: 14, letterSpacing: 0.5, marginRight: 15 }}>RELEVANT REGULATORY EXPECTATIONS</strong>
                        <span>{expanded ? '▲' : '▼'}</span>
                    </a>
                </li>
            </ul>
            {expanded && (
                <div style={{ border: '1px solid #ddd', borderTop: 0, padding: 15, backgroundColor: '#fff' }}>
                    <div>
                        <p style={{ marginBottom: 20 }}>
                            {isLiver
                                ? <>These materials are provided to support transplant centers in their regulatory compliance efforts and supplement &ndash; but do not replace &ndash; each center's own compliance responsibilities. Each transplant center remains responsible for complying with all applicable CMS, Medicare, OPTN, accreditation, and other regulatory requirements.</>
                                : <>These materials align with regulatory expectations related to program approval, contracted services, outcomes monitoring, and Quality Assessment and Performance Improvement (QAPI). They are provided to support transplant centers in their regulatory compliance efforts and supplement &ndash; but do not replace &ndash; each center's own compliance responsibilities. Each transplant center remains responsible for complying with all applicable CMS, Medicare, OPTN, accreditation, and other regulatory requirements.</>
                            }
                        </p>

                        <ol style={{ paddingLeft: 20 }}>
                            {!isLiver && (
                                <>
                                    <li style={{ marginBottom: 16 }}>
                                        <strong>Program Approval &amp; Certification</strong>
                                        <ul style={{ marginTop: 6, paddingLeft: 16 }}>
                                            <li>Medicare Approval of Transplant Programs &mdash; 42 CFR &sect;482.68</li>
                                            <li>Verification of Program Approval &mdash; CMS State Operations Manual, Appendix X, Tag X-001</li>
                                        </ul>
                                    </li>
                                    <li style={{ marginBottom: 16 }}>
                                        <strong>Contracted Services &amp; Program Administration</strong>
                                        <ul style={{ marginTop: 6, paddingLeft: 16 }}>
                                            <li>Contracted Services Oversight &mdash; 42 CFR &sect;482.12(e)</li>
                                            <li>Contracted Services Review &mdash; CMS State Operations Manual, Appendix X Tag X-081</li>
                                        </ul>
                                    </li>
                                    <li style={{ marginBottom: 16 }}>
                                        <strong>Outcome Monitoring &amp; Data Submission</strong>
                                        <ul style={{ marginTop: 6, paddingLeft: 16 }}>
                                            <li>Data Submission and Outcome Monitoring &mdash; 42 CFR &sect;482.80</li>
                                        </ul>
                                    </li>
                                    <li style={{ marginBottom: 16 }}>
                                        <strong>Quality Assessment and Performance Improvement (QAPI)</strong>
                                        <ul style={{ marginTop: 6, paddingLeft: 16 }}>
                                            <li>Quality Assessment and Performance Improvement &mdash; 42 CFR &sect;482.96</li>
                                            <li>QAPI Monitoring, Performance Review, and Program Evaluation &mdash; CMS State Operations Manual, Appendix X, Tags X-099 &ndash; X-101</li>
                                            <li>Patient and Living Donor Management &mdash; 42 CFR &sect;482.94</li>
                                        </ul>
                                    </li>
                                </>
                            )}
                            {isLiver && (
                                <li style={{ marginBottom: 0 }}>
                                    <strong>OPTN Testing Requirements</strong>
                                    <ul style={{ marginTop: 6, paddingLeft: 16 }}>
                                        <li>OPTN Policy 14.4 (Medical Evaluation Requirements for Living Donors)</li>
                                        <li>Including HIV and West Nile Virus testing 7 days prior to donation</li>
                                    </ul>
                                </li>
                            )}
                            {!isLiver && (
                                <li style={{ marginBottom: 16 }}>
                                    <strong>Donor Shield Costs &ndash; Medicare Cost Report</strong>
                                    <p style={{ marginTop: 6, marginBottom: 6 }}>The NKR believes that donor protection costs and donor support costs (non-medical) should not be included on a center's Medicare Cost Report. This position is based on:</p>
                                    <ul style={{ paddingLeft: 16 }}>
                                        <li>42 C.F.R. &sect; 413.402;</li>
                                        <li>The CMS Medicare Provider Reimbursement Manual, Part 1, Ch. 31, &sect; 3106; and</li>
                                        <li>The existence of separate federal grant frameworks administered through HRSA/NLDAC to reimburse donor-incurred non-medical expenses.</li>
                                    </ul>
                                </li>
                            )}
                            {!isLiver && (
                                <li style={{ marginBottom: 0 }}>
                                    <strong>OPTN Testing Requirements</strong>
                                    <ul style={{ marginTop: 6, paddingLeft: 16 }}>
                                        <li>OPTN Policy 14.4 (Medical Evaluation Requirements for Living Donors)</li>
                                        <li>Including HIV and West Nile Virus testing 7 days prior to donation</li>
                                    </ul>
                                </li>
                            )}
                        </ol>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Expectations;
